<template>
	<v-form @submit.prevent="submitForm" ref="formRef" class="d-flex flex-column ga-3 ga-sm-5">




		<ErrorMessage :errorMessage="state.errorMessage" />




		<CustomInput label="First Name" placeholder="Enter your First Name" v-model="state.firstName"
			:error-messages="v$.firstName.$errors.map((e) => e.$message)" @blur="v$.firstName.$touch()" />


		<CustomInput label="Last Name" placeholder="Enter your Last Name" v-model="state.lastName"
			:error-messages="v$.lastName.$errors.map((e) => e.$message)" @blur="v$.lastName.$touch()" />


		<CustomInput label="Email" placeholder="Type your Email" v-model="state.email"
			:error-messages="v$.email.$errors.map((e) => e.$message)" @blur="v$.email.$touch()" />


		<CustomInput label="Password" placeholder="Type your password" type="password" v-model="state.password"
			:error-messages="v$.password.$errors.map((e) => e.$message)" @blur="v$.password.$touch()" />






		<v-checkbox v-model="state.agreeToTerms" density="compact" hide-details>
			<template v-slot:label>



				<div class="pointer text-12 ml-1 weight-500" @click.stop>
					I agree to the
					<a href="#" class="text-primary mx-1" @click.stop="openTerms">Terms of Service</a>
					and
					<a href="#" class="text-primary mx-1" @click.stop="openPrivacyPolicy">Privacy Policy</a>
				</div>


 
			</template>
		</v-checkbox>





		<div class="captcha-container d-flex justify-center align-center align-self-start rounded-8 overflow-hidden">
			<div id="recaptcha" class="recaptcha" data-theme="dark"></div>
		</div>





		<button type="submit" :disabled="isSubmitting" class="button-auth--email rounded-pill">
			<span class="button-auth__text">{{ isSubmitting ? "Signing up..." : "Sign up" }}</span>
		</button>






	</v-form>
</template>



<script lang="ts" setup>

/* global grecaptcha */

import log from "loglevel";
import { useRouter } from "vue-router";
import useVuelidate from "@vuelidate/core";
import { AppConfigs } from "@/app.configs";
import authEvents from "@/Events/AuthDialog";
import { signupRules } from "@/utils/ValidationRules";
import { reactive, ref, onMounted, nextTick } from "vue";
import { AuthService } from "@/api/services/AuthService";
import CustomInput from "@/components/Common/CustomInput.vue";
import ErrorMessage from "@/components/Auth/Common/Messeges/ErrorMessage.vue";
const router = useRouter();




const state = reactive({
	firstName: "",
	lastName: "",
	email: "",
	password: "",
	agreeToTerms: false,
	errorMessage: "",
});
const v$ = useVuelidate(signupRules, state);

const isSubmitting = ref(false);
const isRecaptchaCompleted = ref(false);

onMounted(() => {
	nextTick(() => {
	if (typeof grecaptcha !== 'undefined' && grecaptcha.render) {
		grecaptcha.render('recaptcha', {
		'sitekey': AppConfigs.googleReCaptchaSiteKey,
		'callback': () => {
			isRecaptchaCompleted.value = true;
		},
		});
	} else {
		log.error('grecaptcha is not defined');
	}
	});
});

const submitForm = async () => {
	v$.value.$touch();
	if (v$.value.$invalid) {
		state.errorMessage = "Please fill in all required fields correctly.";
		return;
	}
	if (!state.agreeToTerms) {
		state.errorMessage = "Please agree to the terms and conditions.";
		return;
	}
	if (!isRecaptchaCompleted.value) {
		state.errorMessage = "Please complete the reCAPTCHA.";
		return;
	}
	isSubmitting.value = true;
	state.errorMessage = "";
	try {
		const captchaResponse = grecaptcha.getResponse();
		const response = await AuthService.signup(
			state.firstName,
			state.lastName,
			state.email,
			state.password,
			captchaResponse
		);
		if (response.success) {
			authEvents.emit("signup-verification-email-sent", {
				email: state.email,
				password: state.password,
				firstName: state.firstName,
				lastName: state.lastName,
			});
		} else {
			state.errorMessage = response.message || "Signup failed. Please try again.";
		}
	} catch (error: any) {
		state.errorMessage = error.friendly_message || "An error occurred during signup.";
	} finally {
		isSubmitting.value = false;
		grecaptcha.reset();
		isRecaptchaCompleted.value = false;
	}
};

const openTerms = (event: Event) => {
	event.preventDefault();
	router.push({ name: "TOS" });
	authEvents.emit("close-auth-dialog");
};

const openPrivacyPolicy = (event: Event) => {
	event.preventDefault();
	router.push({ name: "Privacy Policy" });
	authEvents.emit("close-auth-dialog");
};

</script>